@if (!isTreeRoute()) {
  <app-navbar></app-navbar>
}


<mat-sidenav-container class="main-container">
  <mat-sidenav
    #mainSidenav
    mode="over"
    position="end"
    [opened]="(layoutService.activePanel$ | async) !== null"
    (closed)="layoutService.closeSidenav()"
  >
    @switch (layoutService.activePanel$ | async) {
      @case ('notifications') {
        <app-notification-panel (close)="layoutService.closeSidenav()"></app-notification-panel>
      }
      @case ('filters') {
        <app-map-filter (close)="layoutService.closeSidenav()"></app-map-filter>
      }
    }
  </mat-sidenav>

  <mat-sidenav-content>
    <router-outlet (activate)="onRouteActivated()"></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

@if (!isTreeRoute()) {
  @if (isHandset$ | async) {
    <app-bottom-nav></app-bottom-nav>
  } @else {
    <app-footer></app-footer>
  }
}

<ng-container *ngIf="selectedRestStop$ | async as restStop">
  <app-peek-bottom-sheet [restStop]="restStop" (closed)="onBottomSheetClosed()"></app-peek-bottom-sheet>
</ng-container>
